exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weixin-collect-input .collection-input {\n  width: 90%;\n  float: left;\n}\n@media screen and (max-width: 1024px) {\n.weixin-collect-input .collection-input {\n    width: 80%;\n}\n}\n@media screen and (max-width: 580px) {\n.weixin-collect-input .collection-input {\n    width: 70%;\n}\n}\n.weixin-collect-input .collection-btn {\n  float: right;\n}\n.weixin-collect-input .el-loading-spinner {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61e8e952","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/weixinCollectInput.vue
// module id = 1142
// module chunks = 7